import fetch from 'utils/fetch';

export const REQUEST_FORM = 'step4.REQUEST_FORM';
export const RECEIVE_FORM = 'step4.RECEIVE_FORM';
export const UPDATE_FORM = 'step4.UPDATE_FORM';
// export const SAVE_LATER = 'step4.SAVE_LATER';
// export const SAVE_GENERATE = 'step4.SAVE_GENERATE';

function requestForm() {
  return {
    type: REQUEST_FORM,
  };
}

export function receiveForm(form) {
  return {
    type: RECEIVE_FORM,
    payload: form,
  };
}

export function fetchForm(id) {
  return dispatch => {
    dispatch(requestForm());
    fetch(`/pco-manager/cases-creation/${id}/step4.json`)
      .then(r => r.json())
      .then(data => {
        dispatch(receiveForm(data));
      });
  };
}

export const updateForm = data => ({
  type: UPDATE_FORM,
  payload: data,
});

export const saveForLater = (id, data) => {
  console.log('saving for later');
};

export const saveGenerate = (id, data) => {
  console.log('save and generate');
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step4/actions/form.js